<div *ngIf="isActive">
  <div class="parent-container">
    <header>
      <app-header></app-header>
    </header>
  </div>
  <app-notice-banner [data]="transitionBannerData"></app-notice-banner>
  <div class="main-container" [ngClass]="{'background-change':backgroundActive}">
    <router-outlet></router-outlet>
  </div>
  <footer>
    <app-footer></app-footer>
  </footer>
</div>
<ng4-loading-spinner [threshold]="0" [timeout]="600000000" [zIndex]="100000"> </ng4-loading-spinner>

<div class="modal fade " id="tokenExpiry" data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5);">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content font-color">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">Session Expiration Warning</h4>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>

      <!-- Modal body -->
      <div class="modal-body">
        Your session expires in 5 Minutes. Please save all the unsaved items.
      </div>

      <!-- Modal footer -->
      <div class="modal-footer text center">
        <button type="button" class="btn btn-secondary btn-danger" data-dismiss="modal"
          (click)="clearTime()">Ok</button>
      </div>
    </div>
  </div>
</div>